var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h4',[_vm._v(" Relatório ")]),_c('BalanceTable',{attrs:{"data":_vm.report,"dates":_vm.dates,"properties":_vm.propertiesWithData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }